"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getResults = getResults;
exports.questions = void 0;

var _sum2 = _interopRequireDefault(require("lodash/sum"));

var _utils = require("./utils");

var _howOften = _interopRequireDefault(require("../options/howOften"));

var _likertVisual = _interopRequireDefault(require("../options/likertVisual"));

var _health = _interopRequireDefault(require("../options/health"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var batteryId = _utils.screeners.HRQOL;
var baseProps = {
  batteryId: batteryId,
  aggregated: true,
  type: "multi",
  extraText: "Under each heading, please tick the ONE box that best describes your health TODAY",
  options: _howOften["default"]
};
var mobOptions = ["I have no problems in walking about", "I have slight problems in walking about", "I have moderate problems in walking about", "I have severe problems in walking about", "I am unable to walk about"];
var selfCareOptions = ["I have no problems washing or dressing myself", "I have slight problems washing or dressing myself", "I have moderate problems washing or dressing myself", "I have severe problems washing or dressing myself", "I am unable to wash or dress myself"];
var usualActivities = ["I have no problems doing my usual activities", "I have slight problems doing my usual activities", "I have moderate problems doing my usual activities", "I have severe problems doing my usual activities", "I am unable to do my usual activities"];
var painOptions = ["I have no pain or discomfort", "I have slight pain or discomfort", "I have moderate pain or discomfort", "I have severe pain or discomfort", "I have extreme pain or discomfort"];
var anxDepOptions = ["I am not anxious or depressed", "I am slightly anxious or depressed", "I am moderately anxious or depressed", "I am severely anxious or depressed", "I am extremely anxious or depressed"];
var gadQuestions = [{
  prompt: "MOBILITY",
  options: mobOptions,
  type: "dropdown"
}, {
  prompt: "SELF-CARE",
  options: selfCareOptions,
  type: "dropdown"
}, {
  prompt: "USUAL ACTIVITIES (e.g. work, study, housework, family or leisure activities)",
  options: usualActivities,
  type: "dropdown"
}, {
  prompt: "PAIN / DISCOMFORT",
  options: painOptions,
  type: "dropdown"
}, {
  prompt: "ANXIETY / DEPRESSION",
  options: anxDepOptions,
  type: "dropdown"
}, {
  prompt: "Please indicate how good or bad your own health state is today.",
  extraText: "",
  options: _health["default"],
  type: "slider"
}];
var questions = (0, _utils.wrapBattery)(gadQuestions, baseProps);
exports.questions = questions;

function getResults(answers) {
  var score = Math.round((0, _sum2["default"])(answers));
  return {
    HRQOL: score,
    HRQOL_1: answers[0],
    HRQOL_2: answers[1],
    HRQOL_3: answers[2],
    HRQOL_4: answers[3],
    HRQOL_5: answers[4],
    HRQOL_6: answers[5],
    HRQOL_7: answers[6]
  };
}